import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import { Button } from '../../../../components/elements/buttons/Button';

const Multiple = ({ onClick }) => {
    return (
        <Row>
            <input
                type="button"
                className="mr-5 post__footer-answer-button"
                value="Reason"
                onClick={onClick}
            />
        </Row>
    );
};

Multiple.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default React.memo(Multiple);
